import { createAction, props } from "@ngrx/store";
import { ShelterExtendedModel } from "./shelter-extended.reducer";

export const RESET_SHELTERS_EXTENDED = 'Reset Shelters Extended';
export const LIST_OF_SHELTERS_ERROR = 'List Of Shelters Error';
export const LOAD_SHELTERS_EXTENDED = 'Load Shelters Extended';
export const LIST_OF_SHELTERS_EXTENDED = 'List Of Shelters Extended';

export const resetSheltersExtended = createAction(RESET_SHELTERS_EXTENDED);
export const getSheltersError = createAction(LIST_OF_SHELTERS_ERROR,
  props<{ errorCode: string, errorMessage: string }>());
export const loadSheltersExtended = createAction(LOAD_SHELTERS_EXTENDED);
export const getSheltersExtended = createAction(LIST_OF_SHELTERS_EXTENDED,
  props<{ shelters: ShelterExtendedModel[] }>());
